import { AttachmentIcon } from '@chakra-ui/icons';
import { Box, Button, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { useRef } from 'react';

import FieldError from 'components/forms/new/FieldError';
import {
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const Bill = ({
    stateError,
    fileUpload,
    onChange,
    darkMode,
    walkthroughId,
}) => {
    const inputRef = useRef(null);
    return (
        <FormControl
            sx={{
                margin: '0 !important',
            }}
            isRequired
            isInvalid={!fileUpload?.name && stateError?.bill}>
            <Stack
                direction="row"
                sx={{
                    ...stackStyling(),
                    // justifyContent: 'space-between',
                }}>
                <Box width={190}>
                    <FormLabel
                        fontSize="12px"
                        sx={{
                            ...formLabelStyling(darkMode),
                            overflowWrap: 'break-word',
                            whiteSpace: 'normal',
                            paddingY: '15px',
                        }}>
                        Latest bill from your current provider
                    </FormLabel>
                </Box>
                <Box pt="15px" pr="57px">
                    <Button
                        size="sm"
                        colorScheme="brand"
                        className="hover:cursor-pointer"
                        onClick={() => inputRef?.current?.click()}
                        data-walkthroughid={walkthroughId}>
                        {!fileUpload?.name ? (
                            <>
                                Choose File (PDF)
                                <AttachmentIcon ml={1} />
                            </>
                        ) : (
                            fileUpload?.name
                        )}

                        <input
                            style={{ display: 'none' }}
                            type="file"
                            ref={inputRef}
                            id="image-input"
                            onChange={onChange}
                        />
                    </Button>
                </Box>
            </Stack>
            <FieldError>
                {stateError?.bill ||
                    (!fileUpload?.name && 'Field is required.')}
            </FieldError>
        </FormControl>
    );
};

export default Bill;
